import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const SettingsApi = createApi({
  reducerPath: 'settings',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  tagTypes: ['Settings'],
  endpoints: builder => ({
    getSettings: builder.query({
      query: () => ({
        url: `/api/setting`,
        method: 'GET',
      }),
      providesTags: ['Settings'],
    }),
    updateSettings: builder.mutation({
      query: body => ({
        url: `/api/setting`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = SettingsApi;
